/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * Api
 * WindowCleaningSchool API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AnalyticsSettings,
  AnalyticsSummary,
  Appointment,
  AppointmentStatusCount,
  BotTrafficStats,
  BulkImportLeadsBody,
  BulkImportResult,
  Certificate,
  Course,
  CreateAnalyticsSettingsBody,
  CreateAppointmentBody,
  CreateCertificateBody,
  CreateCourseBody,
  CreateInvoiceBody,
  CreateLeadBody,
  CreateNotificationBody,
  CreateRequirementBody,
  CreateUserBody,
  EngagementMetrics,
  HealthStatus,
  Invoice,
  Lead,
  ListAppointmentsParams,
  ListCertificatesParams,
  ListContentParams,
  ListInvoicesParams,
  ListLeadsParams,
  ListNotificationsParams,
  ListRequirementsParams,
  LogTrafficBody,
  Notification,
  Requirement,
  RevenueByMonth,
  SiteContent,
  TrafficByDay,
  TrafficLog,
  TrafficSource,
  UpdateAnalyticsSettingsBody,
  UpdateAppointmentBody,
  UpdateCertificateBody,
  UpdateContentBody,
  UpdateCourseBody,
  UpdateInvoiceBody,
  UpdateLeadBody,
  UpdateRequirementBody,
  UpdateUserBody,
  User
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Health check
 */
export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary List all users
 */
export const getListUsersUrl = () => {




  return `/api/users`
}

export const listUsers = async ( options?: RequestInit): Promise<User[]> => {

  return customFetch<User[]>(getListUsersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUsersQueryKey = () => {
    return [
    `/api/users`
    ] as const;
    }


export const getListUsersQueryOptions = <TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUsersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsers>>> = ({ signal }) => listUsers({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listUsers>>>
export type ListUsersQueryError = ErrorType<unknown>


/**
 * @summary List all users
 */

export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListUsersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create or update a user (upsert by email)
 */
export const getCreateUserUrl = () => {




  return `/api/users`
}

export const createUser = async (createUserBody: CreateUserBody, options?: RequestInit): Promise<User> => {

  return customFetch<User>(getCreateUserUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createUserBody,)
  }
);}




export const getCreateUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: BodyType<CreateUserBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: BodyType<CreateUserBody>}, TContext> => {

const mutationKey = ['createUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUser>>, {data: BodyType<CreateUserBody>}> = (props) => {
          const {data} = props ?? {};

          return  createUser(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUserMutationResult = NonNullable<Awaited<ReturnType<typeof createUser>>>
    export type CreateUserMutationBody = BodyType<CreateUserBody>
    export type CreateUserMutationError = ErrorType<unknown>

    /**
 * @summary Create or update a user (upsert by email)
 */
export const useCreateUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: BodyType<CreateUserBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createUser>>,
        TError,
        {data: BodyType<CreateUserBody>},
        TContext
      > => {
      return useMutation(getCreateUserMutationOptions(options));
    }

/**
 * @summary Get user by ID
 */
export const getGetUserUrl = (id: number,) => {




  return `/api/users/${id}`
}

export const getUser = async (id: number, options?: RequestInit): Promise<User> => {

  return customFetch<User>(getGetUserUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUserQueryKey = (id: number,) => {
    return [
    `/api/users/${id}`
    ] as const;
    }


export const getGetUserQueryOptions = <TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({ signal }) => getUser(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserQueryResult = NonNullable<Awaited<ReturnType<typeof getUser>>>
export type GetUserQueryError = ErrorType<void>


/**
 * @summary Get user by ID
 */

export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUserQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Update a user
 */
export const getUpdateUserUrl = (id: number,) => {




  return `/api/users/${id}`
}

export const updateUser = async (id: number,
    updateUserBody: UpdateUserBody, options?: RequestInit): Promise<User> => {

  return customFetch<User>(getUpdateUserUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateUserBody,)
  }
);}




export const getUpdateUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{id: number;data: BodyType<UpdateUserBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{id: number;data: BodyType<UpdateUserBody>}, TContext> => {

const mutationKey = ['updateUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUser>>, {id: number;data: BodyType<UpdateUserBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateUser(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>
    export type UpdateUserMutationBody = BodyType<UpdateUserBody>
    export type UpdateUserMutationError = ErrorType<unknown>

    /**
 * @summary Update a user
 */
export const useUpdateUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{id: number;data: BodyType<UpdateUserBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateUser>>,
        TError,
        {id: number;data: BodyType<UpdateUserBody>},
        TContext
      > => {
      return useMutation(getUpdateUserMutationOptions(options));
    }

/**
 * @summary List all courses
 */
export const getListCoursesUrl = () => {




  return `/api/courses`
}

export const listCourses = async ( options?: RequestInit): Promise<Course[]> => {

  return customFetch<Course[]>(getListCoursesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCoursesQueryKey = () => {
    return [
    `/api/courses`
    ] as const;
    }


export const getListCoursesQueryOptions = <TData = Awaited<ReturnType<typeof listCourses>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCourses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCoursesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCourses>>> = ({ signal }) => listCourses({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCourses>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCoursesQueryResult = NonNullable<Awaited<ReturnType<typeof listCourses>>>
export type ListCoursesQueryError = ErrorType<unknown>


/**
 * @summary List all courses
 */

export function useListCourses<TData = Awaited<ReturnType<typeof listCourses>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCourses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCoursesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create a course
 */
export const getCreateCourseUrl = () => {




  return `/api/courses`
}

export const createCourse = async (createCourseBody: CreateCourseBody, options?: RequestInit): Promise<Course> => {

  return customFetch<Course>(getCreateCourseUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createCourseBody,)
  }
);}




export const getCreateCourseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCourse>>, TError,{data: BodyType<CreateCourseBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCourse>>, TError,{data: BodyType<CreateCourseBody>}, TContext> => {

const mutationKey = ['createCourse'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCourse>>, {data: BodyType<CreateCourseBody>}> = (props) => {
          const {data} = props ?? {};

          return  createCourse(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCourseMutationResult = NonNullable<Awaited<ReturnType<typeof createCourse>>>
    export type CreateCourseMutationBody = BodyType<CreateCourseBody>
    export type CreateCourseMutationError = ErrorType<unknown>

    /**
 * @summary Create a course
 */
export const useCreateCourse = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCourse>>, TError,{data: BodyType<CreateCourseBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCourse>>,
        TError,
        {data: BodyType<CreateCourseBody>},
        TContext
      > => {
      return useMutation(getCreateCourseMutationOptions(options));
    }

/**
 * @summary Get course by ID
 */
export const getGetCourseUrl = (id: number,) => {




  return `/api/courses/${id}`
}

export const getCourse = async (id: number, options?: RequestInit): Promise<Course> => {

  return customFetch<Course>(getGetCourseUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCourseQueryKey = (id: number,) => {
    return [
    `/api/courses/${id}`
    ] as const;
    }


export const getGetCourseQueryOptions = <TData = Awaited<ReturnType<typeof getCourse>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCourse>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCourseQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourse>>> = ({ signal }) => getCourse(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCourse>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCourseQueryResult = NonNullable<Awaited<ReturnType<typeof getCourse>>>
export type GetCourseQueryError = ErrorType<unknown>


/**
 * @summary Get course by ID
 */

export function useGetCourse<TData = Awaited<ReturnType<typeof getCourse>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCourse>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCourseQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Update a course
 */
export const getUpdateCourseUrl = (id: number,) => {




  return `/api/courses/${id}`
}

export const updateCourse = async (id: number,
    updateCourseBody: UpdateCourseBody, options?: RequestInit): Promise<Course> => {

  return customFetch<Course>(getUpdateCourseUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateCourseBody,)
  }
);}




export const getUpdateCourseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCourse>>, TError,{id: number;data: BodyType<UpdateCourseBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCourse>>, TError,{id: number;data: BodyType<UpdateCourseBody>}, TContext> => {

const mutationKey = ['updateCourse'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCourse>>, {id: number;data: BodyType<UpdateCourseBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCourse(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCourseMutationResult = NonNullable<Awaited<ReturnType<typeof updateCourse>>>
    export type UpdateCourseMutationBody = BodyType<UpdateCourseBody>
    export type UpdateCourseMutationError = ErrorType<unknown>

    /**
 * @summary Update a course
 */
export const useUpdateCourse = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCourse>>, TError,{id: number;data: BodyType<UpdateCourseBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCourse>>,
        TError,
        {id: number;data: BodyType<UpdateCourseBody>},
        TContext
      > => {
      return useMutation(getUpdateCourseMutationOptions(options));
    }

/**
 * @summary Delete a course
 */
export const getDeleteCourseUrl = (id: number,) => {




  return `/api/courses/${id}`
}

export const deleteCourse = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteCourseUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteCourseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCourse>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCourse>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCourse'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCourse>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCourse(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCourseMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCourse>>>

    export type DeleteCourseMutationError = ErrorType<unknown>

    /**
 * @summary Delete a course
 */
export const useDeleteCourse = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCourse>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCourse>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCourseMutationOptions(options));
    }

/**
 * @summary List appointments
 */
export const getListAppointmentsUrl = (params?: ListAppointmentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/appointments?${stringifiedParams}` : `/api/appointments`
}

export const listAppointments = async (params?: ListAppointmentsParams, options?: RequestInit): Promise<Appointment[]> => {

  return customFetch<Appointment[]>(getListAppointmentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAppointmentsQueryKey = (params?: ListAppointmentsParams,) => {
    return [
    `/api/appointments`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAppointmentsQueryOptions = <TData = Awaited<ReturnType<typeof listAppointments>>, TError = ErrorType<unknown>>(params?: ListAppointmentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAppointments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAppointmentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAppointments>>> = ({ signal }) => listAppointments(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAppointments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAppointmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listAppointments>>>
export type ListAppointmentsQueryError = ErrorType<unknown>


/**
 * @summary List appointments
 */

export function useListAppointments<TData = Awaited<ReturnType<typeof listAppointments>>, TError = ErrorType<unknown>>(
 params?: ListAppointmentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAppointments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAppointmentsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Book an appointment
 */
export const getCreateAppointmentUrl = () => {




  return `/api/appointments`
}

export const createAppointment = async (createAppointmentBody: CreateAppointmentBody, options?: RequestInit): Promise<Appointment> => {

  return customFetch<Appointment>(getCreateAppointmentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createAppointmentBody,)
  }
);}




export const getCreateAppointmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAppointment>>, TError,{data: BodyType<CreateAppointmentBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAppointment>>, TError,{data: BodyType<CreateAppointmentBody>}, TContext> => {

const mutationKey = ['createAppointment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAppointment>>, {data: BodyType<CreateAppointmentBody>}> = (props) => {
          const {data} = props ?? {};

          return  createAppointment(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAppointmentMutationResult = NonNullable<Awaited<ReturnType<typeof createAppointment>>>
    export type CreateAppointmentMutationBody = BodyType<CreateAppointmentBody>
    export type CreateAppointmentMutationError = ErrorType<unknown>

    /**
 * @summary Book an appointment
 */
export const useCreateAppointment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAppointment>>, TError,{data: BodyType<CreateAppointmentBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAppointment>>,
        TError,
        {data: BodyType<CreateAppointmentBody>},
        TContext
      > => {
      return useMutation(getCreateAppointmentMutationOptions(options));
    }

/**
 * @summary Get appointment by ID
 */
export const getGetAppointmentUrl = (id: number,) => {




  return `/api/appointments/${id}`
}

export const getAppointment = async (id: number, options?: RequestInit): Promise<Appointment> => {

  return customFetch<Appointment>(getGetAppointmentUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAppointmentQueryKey = (id: number,) => {
    return [
    `/api/appointments/${id}`
    ] as const;
    }


export const getGetAppointmentQueryOptions = <TData = Awaited<ReturnType<typeof getAppointment>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAppointment>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAppointmentQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppointment>>> = ({ signal }) => getAppointment(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAppointment>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAppointmentQueryResult = NonNullable<Awaited<ReturnType<typeof getAppointment>>>
export type GetAppointmentQueryError = ErrorType<unknown>


/**
 * @summary Get appointment by ID
 */

export function useGetAppointment<TData = Awaited<ReturnType<typeof getAppointment>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAppointment>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAppointmentQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Update appointment status or details
 */
export const getUpdateAppointmentUrl = (id: number,) => {




  return `/api/appointments/${id}`
}

export const updateAppointment = async (id: number,
    updateAppointmentBody: UpdateAppointmentBody, options?: RequestInit): Promise<Appointment> => {

  return customFetch<Appointment>(getUpdateAppointmentUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateAppointmentBody,)
  }
);}




export const getUpdateAppointmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAppointment>>, TError,{id: number;data: BodyType<UpdateAppointmentBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAppointment>>, TError,{id: number;data: BodyType<UpdateAppointmentBody>}, TContext> => {

const mutationKey = ['updateAppointment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAppointment>>, {id: number;data: BodyType<UpdateAppointmentBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAppointment(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAppointmentMutationResult = NonNullable<Awaited<ReturnType<typeof updateAppointment>>>
    export type UpdateAppointmentMutationBody = BodyType<UpdateAppointmentBody>
    export type UpdateAppointmentMutationError = ErrorType<unknown>

    /**
 * @summary Update appointment status or details
 */
export const useUpdateAppointment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAppointment>>, TError,{id: number;data: BodyType<UpdateAppointmentBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAppointment>>,
        TError,
        {id: number;data: BodyType<UpdateAppointmentBody>},
        TContext
      > => {
      return useMutation(getUpdateAppointmentMutationOptions(options));
    }

/**
 * @summary Cancel/delete appointment
 */
export const getDeleteAppointmentUrl = (id: number,) => {




  return `/api/appointments/${id}`
}

export const deleteAppointment = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteAppointmentUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteAppointmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAppointment>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAppointment>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteAppointment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAppointment>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteAppointment(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAppointmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAppointment>>>

    export type DeleteAppointmentMutationError = ErrorType<unknown>

    /**
 * @summary Cancel/delete appointment
 */
export const useDeleteAppointment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAppointment>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAppointment>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteAppointmentMutationOptions(options));
    }

/**
 * @summary Log a page view
 */
export const getLogTrafficUrl = () => {




  return `/api/traffic`
}

export const logTraffic = async (logTrafficBody: LogTrafficBody, options?: RequestInit): Promise<TrafficLog> => {

  return customFetch<TrafficLog>(getLogTrafficUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      logTrafficBody,)
  }
);}




export const getLogTrafficMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logTraffic>>, TError,{data: BodyType<LogTrafficBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof logTraffic>>, TError,{data: BodyType<LogTrafficBody>}, TContext> => {

const mutationKey = ['logTraffic'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logTraffic>>, {data: BodyType<LogTrafficBody>}> = (props) => {
          const {data} = props ?? {};

          return  logTraffic(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogTrafficMutationResult = NonNullable<Awaited<ReturnType<typeof logTraffic>>>
    export type LogTrafficMutationBody = BodyType<LogTrafficBody>
    export type LogTrafficMutationError = ErrorType<unknown>

    /**
 * @summary Log a page view
 */
export const useLogTraffic = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logTraffic>>, TError,{data: BodyType<LogTrafficBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof logTraffic>>,
        TError,
        {data: BodyType<LogTrafficBody>},
        TContext
      > => {
      return useMutation(getLogTrafficMutationOptions(options));
    }

/**
 * @summary Get analytics summary (admin dashboard stats)
 */
export const getGetAnalyticsSummaryUrl = () => {




  return `/api/analytics/summary`
}

export const getAnalyticsSummary = async ( options?: RequestInit): Promise<AnalyticsSummary> => {

  return customFetch<AnalyticsSummary>(getGetAnalyticsSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAnalyticsSummaryQueryKey = () => {
    return [
    `/api/analytics/summary`
    ] as const;
    }


export const getGetAnalyticsSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getAnalyticsSummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalyticsSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalyticsSummary>>> = ({ signal }) => getAnalyticsSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAnalyticsSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalyticsSummary>>>
export type GetAnalyticsSummaryQueryError = ErrorType<unknown>


/**
 * @summary Get analytics summary (admin dashboard stats)
 */

export function useGetAnalyticsSummary<TData = Awaited<ReturnType<typeof getAnalyticsSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAnalyticsSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Page views grouped by day (last 30 days)
 */
export const getGetTrafficByDayUrl = () => {




  return `/api/analytics/traffic-by-day`
}

export const getTrafficByDay = async ( options?: RequestInit): Promise<TrafficByDay[]> => {

  return customFetch<TrafficByDay[]>(getGetTrafficByDayUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTrafficByDayQueryKey = () => {
    return [
    `/api/analytics/traffic-by-day`
    ] as const;
    }


export const getGetTrafficByDayQueryOptions = <TData = Awaited<ReturnType<typeof getTrafficByDay>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTrafficByDay>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrafficByDayQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrafficByDay>>> = ({ signal }) => getTrafficByDay({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTrafficByDay>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTrafficByDayQueryResult = NonNullable<Awaited<ReturnType<typeof getTrafficByDay>>>
export type GetTrafficByDayQueryError = ErrorType<unknown>


/**
 * @summary Page views grouped by day (last 30 days)
 */

export function useGetTrafficByDay<TData = Awaited<ReturnType<typeof getTrafficByDay>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTrafficByDay>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTrafficByDayQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Appointment counts by status
 */
export const getGetAppointmentsByStatusUrl = () => {




  return `/api/analytics/appointments-by-status`
}

export const getAppointmentsByStatus = async ( options?: RequestInit): Promise<AppointmentStatusCount[]> => {

  return customFetch<AppointmentStatusCount[]>(getGetAppointmentsByStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAppointmentsByStatusQueryKey = () => {
    return [
    `/api/analytics/appointments-by-status`
    ] as const;
    }


export const getGetAppointmentsByStatusQueryOptions = <TData = Awaited<ReturnType<typeof getAppointmentsByStatus>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAppointmentsByStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAppointmentsByStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppointmentsByStatus>>> = ({ signal }) => getAppointmentsByStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAppointmentsByStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAppointmentsByStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getAppointmentsByStatus>>>
export type GetAppointmentsByStatusQueryError = ErrorType<unknown>


/**
 * @summary Appointment counts by status
 */

export function useGetAppointmentsByStatus<TData = Awaited<ReturnType<typeof getAppointmentsByStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAppointmentsByStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAppointmentsByStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Revenue stats by month
 */
export const getGetRevenueStatsUrl = () => {




  return `/api/analytics/revenue`
}

export const getRevenueStats = async ( options?: RequestInit): Promise<RevenueByMonth[]> => {

  return customFetch<RevenueByMonth[]>(getGetRevenueStatsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRevenueStatsQueryKey = () => {
    return [
    `/api/analytics/revenue`
    ] as const;
    }


export const getGetRevenueStatsQueryOptions = <TData = Awaited<ReturnType<typeof getRevenueStats>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRevenueStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRevenueStatsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRevenueStats>>> = ({ signal }) => getRevenueStats({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRevenueStats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRevenueStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getRevenueStats>>>
export type GetRevenueStatsQueryError = ErrorType<unknown>


/**
 * @summary Revenue stats by month
 */

export function useGetRevenueStats<TData = Awaited<ReturnType<typeof getRevenueStats>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRevenueStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRevenueStatsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get traffic breakdown by source
 */
export const getGetTrafficSourcesUrl = () => {




  return `/api/analytics/traffic-sources`
}

export const getTrafficSources = async ( options?: RequestInit): Promise<TrafficSource[]> => {

  return customFetch<TrafficSource[]>(getGetTrafficSourcesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTrafficSourcesQueryKey = () => {
    return [
    `/api/analytics/traffic-sources`
    ] as const;
    }


export const getGetTrafficSourcesQueryOptions = <TData = Awaited<ReturnType<typeof getTrafficSources>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTrafficSources>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrafficSourcesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrafficSources>>> = ({ signal }) => getTrafficSources({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTrafficSources>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTrafficSourcesQueryResult = NonNullable<Awaited<ReturnType<typeof getTrafficSources>>>
export type GetTrafficSourcesQueryError = ErrorType<unknown>


/**
 * @summary Get traffic breakdown by source
 */

export function useGetTrafficSources<TData = Awaited<ReturnType<typeof getTrafficSources>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTrafficSources>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTrafficSourcesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get bot vs human traffic stats
 */
export const getGetBotTrafficUrl = () => {




  return `/api/analytics/bot-traffic`
}

export const getBotTraffic = async ( options?: RequestInit): Promise<BotTrafficStats> => {

  return customFetch<BotTrafficStats>(getGetBotTrafficUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBotTrafficQueryKey = () => {
    return [
    `/api/analytics/bot-traffic`
    ] as const;
    }


export const getGetBotTrafficQueryOptions = <TData = Awaited<ReturnType<typeof getBotTraffic>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBotTraffic>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBotTrafficQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBotTraffic>>> = ({ signal }) => getBotTraffic({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBotTraffic>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBotTrafficQueryResult = NonNullable<Awaited<ReturnType<typeof getBotTraffic>>>
export type GetBotTrafficQueryError = ErrorType<unknown>


/**
 * @summary Get bot vs human traffic stats
 */

export function useGetBotTraffic<TData = Awaited<ReturnType<typeof getBotTraffic>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBotTraffic>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBotTrafficQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get engagement metrics (bounce rate, session duration, etc.)
 */
export const getGetEngagementMetricsUrl = () => {




  return `/api/analytics/engagement`
}

export const getEngagementMetrics = async ( options?: RequestInit): Promise<EngagementMetrics> => {

  return customFetch<EngagementMetrics>(getGetEngagementMetricsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEngagementMetricsQueryKey = () => {
    return [
    `/api/analytics/engagement`
    ] as const;
    }


export const getGetEngagementMetricsQueryOptions = <TData = Awaited<ReturnType<typeof getEngagementMetrics>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEngagementMetrics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEngagementMetricsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEngagementMetrics>>> = ({ signal }) => getEngagementMetrics({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEngagementMetrics>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEngagementMetricsQueryResult = NonNullable<Awaited<ReturnType<typeof getEngagementMetrics>>>
export type GetEngagementMetricsQueryError = ErrorType<unknown>


/**
 * @summary Get engagement metrics (bounce rate, session duration, etc.)
 */

export function useGetEngagementMetrics<TData = Awaited<ReturnType<typeof getEngagementMetrics>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEngagementMetrics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEngagementMetricsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get analytics integration settings
 */
export const getGetAnalyticsSettingsUrl = () => {




  return `/api/analytics/settings`
}

export const getAnalyticsSettings = async ( options?: RequestInit): Promise<AnalyticsSettings[]> => {

  return customFetch<AnalyticsSettings[]>(getGetAnalyticsSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAnalyticsSettingsQueryKey = () => {
    return [
    `/api/analytics/settings`
    ] as const;
    }


export const getGetAnalyticsSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getAnalyticsSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalyticsSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalyticsSettings>>> = ({ signal }) => getAnalyticsSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAnalyticsSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalyticsSettings>>>
export type GetAnalyticsSettingsQueryError = ErrorType<unknown>


/**
 * @summary Get analytics integration settings
 */

export function useGetAnalyticsSettings<TData = Awaited<ReturnType<typeof getAnalyticsSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAnalyticsSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Add analytics integration
 */
export const getCreateAnalyticsSettingsUrl = () => {




  return `/api/analytics/settings`
}

export const createAnalyticsSettings = async (createAnalyticsSettingsBody: CreateAnalyticsSettingsBody, options?: RequestInit): Promise<AnalyticsSettings> => {

  return customFetch<AnalyticsSettings>(getCreateAnalyticsSettingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createAnalyticsSettingsBody,)
  }
);}




export const getCreateAnalyticsSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnalyticsSettings>>, TError,{data: BodyType<CreateAnalyticsSettingsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAnalyticsSettings>>, TError,{data: BodyType<CreateAnalyticsSettingsBody>}, TContext> => {

const mutationKey = ['createAnalyticsSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAnalyticsSettings>>, {data: BodyType<CreateAnalyticsSettingsBody>}> = (props) => {
          const {data} = props ?? {};

          return  createAnalyticsSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAnalyticsSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof createAnalyticsSettings>>>
    export type CreateAnalyticsSettingsMutationBody = BodyType<CreateAnalyticsSettingsBody>
    export type CreateAnalyticsSettingsMutationError = ErrorType<unknown>

    /**
 * @summary Add analytics integration
 */
export const useCreateAnalyticsSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnalyticsSettings>>, TError,{data: BodyType<CreateAnalyticsSettingsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAnalyticsSettings>>,
        TError,
        {data: BodyType<CreateAnalyticsSettingsBody>},
        TContext
      > => {
      return useMutation(getCreateAnalyticsSettingsMutationOptions(options));
    }

/**
 * @summary Update analytics settings
 */
export const getUpdateAnalyticsSettingsUrl = (id: number,) => {




  return `/api/analytics/settings/${id}`
}

export const updateAnalyticsSettings = async (id: number,
    updateAnalyticsSettingsBody: UpdateAnalyticsSettingsBody, options?: RequestInit): Promise<AnalyticsSettings> => {

  return customFetch<AnalyticsSettings>(getUpdateAnalyticsSettingsUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateAnalyticsSettingsBody,)
  }
);}




export const getUpdateAnalyticsSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAnalyticsSettings>>, TError,{id: number;data: BodyType<UpdateAnalyticsSettingsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAnalyticsSettings>>, TError,{id: number;data: BodyType<UpdateAnalyticsSettingsBody>}, TContext> => {

const mutationKey = ['updateAnalyticsSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAnalyticsSettings>>, {id: number;data: BodyType<UpdateAnalyticsSettingsBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAnalyticsSettings(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAnalyticsSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateAnalyticsSettings>>>
    export type UpdateAnalyticsSettingsMutationBody = BodyType<UpdateAnalyticsSettingsBody>
    export type UpdateAnalyticsSettingsMutationError = ErrorType<unknown>

    /**
 * @summary Update analytics settings
 */
export const useUpdateAnalyticsSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAnalyticsSettings>>, TError,{id: number;data: BodyType<UpdateAnalyticsSettingsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAnalyticsSettings>>,
        TError,
        {id: number;data: BodyType<UpdateAnalyticsSettingsBody>},
        TContext
      > => {
      return useMutation(getUpdateAnalyticsSettingsMutationOptions(options));
    }

/**
 * @summary List notifications for a user
 */
export const getListNotificationsUrl = (params: ListNotificationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/notifications?${stringifiedParams}` : `/api/notifications`
}

export const listNotifications = async (params: ListNotificationsParams, options?: RequestInit): Promise<Notification[]> => {

  return customFetch<Notification[]>(getListNotificationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListNotificationsQueryKey = (params?: ListNotificationsParams,) => {
    return [
    `/api/notifications`, ...(params ? [params] : [])
    ] as const;
    }


export const getListNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof listNotifications>>, TError = ErrorType<unknown>>(params: ListNotificationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNotificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotifications>>> = ({ signal }) => listNotifications(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData> & { queryKey: QueryKey }
}

export type ListNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof listNotifications>>>
export type ListNotificationsQueryError = ErrorType<unknown>


/**
 * @summary List notifications for a user
 */

export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = ErrorType<unknown>>(
 params: ListNotificationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create a notification for a user
 */
export const getCreateNotificationUrl = () => {




  return `/api/notifications`
}

export const createNotification = async (createNotificationBody: CreateNotificationBody, options?: RequestInit): Promise<Notification> => {

  return customFetch<Notification>(getCreateNotificationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createNotificationBody,)
  }
);}




export const getCreateNotificationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNotification>>, TError,{data: BodyType<CreateNotificationBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createNotification>>, TError,{data: BodyType<CreateNotificationBody>}, TContext> => {

const mutationKey = ['createNotification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNotification>>, {data: BodyType<CreateNotificationBody>}> = (props) => {
          const {data} = props ?? {};

          return  createNotification(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof createNotification>>>
    export type CreateNotificationMutationBody = BodyType<CreateNotificationBody>
    export type CreateNotificationMutationError = ErrorType<unknown>

    /**
 * @summary Create a notification for a user
 */
export const useCreateNotification = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNotification>>, TError,{data: BodyType<CreateNotificationBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createNotification>>,
        TError,
        {data: BodyType<CreateNotificationBody>},
        TContext
      > => {
      return useMutation(getCreateNotificationMutationOptions(options));
    }

/**
 * @summary Mark notification as read
 */
export const getMarkNotificationReadUrl = (id: number,) => {




  return `/api/notifications/${id}/read`
}

export const markNotificationRead = async (id: number, options?: RequestInit): Promise<Notification> => {

  return customFetch<Notification>(getMarkNotificationReadUrl(id),
  {
    ...options,
    method: 'PATCH'


  }
);}




export const getMarkNotificationReadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError,{id: number}, TContext> => {

const mutationKey = ['markNotificationRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markNotificationRead>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  markNotificationRead(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkNotificationReadMutationResult = NonNullable<Awaited<ReturnType<typeof markNotificationRead>>>

    export type MarkNotificationReadMutationError = ErrorType<unknown>

    /**
 * @summary Mark notification as read
 */
export const useMarkNotificationRead = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markNotificationRead>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getMarkNotificationReadMutationOptions(options));
    }

/**
 * @summary List certificates
 */
export const getListCertificatesUrl = (params?: ListCertificatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/certificates?${stringifiedParams}` : `/api/certificates`
}

export const listCertificates = async (params?: ListCertificatesParams, options?: RequestInit): Promise<Certificate[]> => {

  return customFetch<Certificate[]>(getListCertificatesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCertificatesQueryKey = (params?: ListCertificatesParams,) => {
    return [
    `/api/certificates`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCertificatesQueryOptions = <TData = Awaited<ReturnType<typeof listCertificates>>, TError = ErrorType<unknown>>(params?: ListCertificatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCertificates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCertificatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCertificates>>> = ({ signal }) => listCertificates(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCertificates>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCertificatesQueryResult = NonNullable<Awaited<ReturnType<typeof listCertificates>>>
export type ListCertificatesQueryError = ErrorType<unknown>


/**
 * @summary List certificates
 */

export function useListCertificates<TData = Awaited<ReturnType<typeof listCertificates>>, TError = ErrorType<unknown>>(
 params?: ListCertificatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCertificates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCertificatesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create a certificate
 */
export const getCreateCertificateUrl = () => {




  return `/api/certificates`
}

export const createCertificate = async (createCertificateBody: CreateCertificateBody, options?: RequestInit): Promise<Certificate> => {

  return customFetch<Certificate>(getCreateCertificateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createCertificateBody,)
  }
);}




export const getCreateCertificateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCertificate>>, TError,{data: BodyType<CreateCertificateBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCertificate>>, TError,{data: BodyType<CreateCertificateBody>}, TContext> => {

const mutationKey = ['createCertificate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCertificate>>, {data: BodyType<CreateCertificateBody>}> = (props) => {
          const {data} = props ?? {};

          return  createCertificate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCertificateMutationResult = NonNullable<Awaited<ReturnType<typeof createCertificate>>>
    export type CreateCertificateMutationBody = BodyType<CreateCertificateBody>
    export type CreateCertificateMutationError = ErrorType<unknown>

    /**
 * @summary Create a certificate
 */
export const useCreateCertificate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCertificate>>, TError,{data: BodyType<CreateCertificateBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCertificate>>,
        TError,
        {data: BodyType<CreateCertificateBody>},
        TContext
      > => {
      return useMutation(getCreateCertificateMutationOptions(options));
    }

/**
 * @summary Update certificate status
 */
export const getUpdateCertificateUrl = (id: number,) => {




  return `/api/certificates/${id}`
}

export const updateCertificate = async (id: number,
    updateCertificateBody: UpdateCertificateBody, options?: RequestInit): Promise<Certificate> => {

  return customFetch<Certificate>(getUpdateCertificateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateCertificateBody,)
  }
);}




export const getUpdateCertificateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCertificate>>, TError,{id: number;data: BodyType<UpdateCertificateBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCertificate>>, TError,{id: number;data: BodyType<UpdateCertificateBody>}, TContext> => {

const mutationKey = ['updateCertificate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCertificate>>, {id: number;data: BodyType<UpdateCertificateBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCertificate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCertificateMutationResult = NonNullable<Awaited<ReturnType<typeof updateCertificate>>>
    export type UpdateCertificateMutationBody = BodyType<UpdateCertificateBody>
    export type UpdateCertificateMutationError = ErrorType<unknown>

    /**
 * @summary Update certificate status
 */
export const useUpdateCertificate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCertificate>>, TError,{id: number;data: BodyType<UpdateCertificateBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCertificate>>,
        TError,
        {id: number;data: BodyType<UpdateCertificateBody>},
        TContext
      > => {
      return useMutation(getUpdateCertificateMutationOptions(options));
    }

/**
 * @summary List invoices
 */
export const getListInvoicesUrl = (params?: ListInvoicesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/invoices?${stringifiedParams}` : `/api/invoices`
}

export const listInvoices = async (params?: ListInvoicesParams, options?: RequestInit): Promise<Invoice[]> => {

  return customFetch<Invoice[]>(getListInvoicesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInvoicesQueryKey = (params?: ListInvoicesParams,) => {
    return [
    `/api/invoices`, ...(params ? [params] : [])
    ] as const;
    }


export const getListInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof listInvoices>>, TError = ErrorType<unknown>>(params?: ListInvoicesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInvoices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInvoicesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvoices>>> = ({ signal }) => listInvoices(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInvoices>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof listInvoices>>>
export type ListInvoicesQueryError = ErrorType<unknown>


/**
 * @summary List invoices
 */

export function useListInvoices<TData = Awaited<ReturnType<typeof listInvoices>>, TError = ErrorType<unknown>>(
 params?: ListInvoicesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInvoices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInvoicesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create an invoice
 */
export const getCreateInvoiceUrl = () => {




  return `/api/invoices`
}

export const createInvoice = async (createInvoiceBody: CreateInvoiceBody, options?: RequestInit): Promise<Invoice> => {

  return customFetch<Invoice>(getCreateInvoiceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createInvoiceBody,)
  }
);}




export const getCreateInvoiceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvoice>>, TError,{data: BodyType<CreateInvoiceBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInvoice>>, TError,{data: BodyType<CreateInvoiceBody>}, TContext> => {

const mutationKey = ['createInvoice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInvoice>>, {data: BodyType<CreateInvoiceBody>}> = (props) => {
          const {data} = props ?? {};

          return  createInvoice(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof createInvoice>>>
    export type CreateInvoiceMutationBody = BodyType<CreateInvoiceBody>
    export type CreateInvoiceMutationError = ErrorType<unknown>

    /**
 * @summary Create an invoice
 */
export const useCreateInvoice = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvoice>>, TError,{data: BodyType<CreateInvoiceBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createInvoice>>,
        TError,
        {data: BodyType<CreateInvoiceBody>},
        TContext
      > => {
      return useMutation(getCreateInvoiceMutationOptions(options));
    }

/**
 * @summary Get invoice by ID
 */
export const getGetInvoiceUrl = (id: number,) => {




  return `/api/invoices/${id}`
}

export const getInvoice = async (id: number, options?: RequestInit): Promise<Invoice> => {

  return customFetch<Invoice>(getGetInvoiceUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInvoiceQueryKey = (id: number,) => {
    return [
    `/api/invoices/${id}`
    ] as const;
    }


export const getGetInvoiceQueryOptions = <TData = Awaited<ReturnType<typeof getInvoice>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoiceQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoice>>> = ({ signal }) => getInvoice(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInvoiceQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoice>>>
export type GetInvoiceQueryError = ErrorType<unknown>


/**
 * @summary Get invoice by ID
 */

export function useGetInvoice<TData = Awaited<ReturnType<typeof getInvoice>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInvoiceQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Update invoice
 */
export const getUpdateInvoiceUrl = (id: number,) => {




  return `/api/invoices/${id}`
}

export const updateInvoice = async (id: number,
    updateInvoiceBody: UpdateInvoiceBody, options?: RequestInit): Promise<Invoice> => {

  return customFetch<Invoice>(getUpdateInvoiceUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateInvoiceBody,)
  }
);}




export const getUpdateInvoiceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInvoice>>, TError,{id: number;data: BodyType<UpdateInvoiceBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInvoice>>, TError,{id: number;data: BodyType<UpdateInvoiceBody>}, TContext> => {

const mutationKey = ['updateInvoice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInvoice>>, {id: number;data: BodyType<UpdateInvoiceBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateInvoice(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof updateInvoice>>>
    export type UpdateInvoiceMutationBody = BodyType<UpdateInvoiceBody>
    export type UpdateInvoiceMutationError = ErrorType<unknown>

    /**
 * @summary Update invoice
 */
export const useUpdateInvoice = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInvoice>>, TError,{id: number;data: BodyType<UpdateInvoiceBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateInvoice>>,
        TError,
        {id: number;data: BodyType<UpdateInvoiceBody>},
        TContext
      > => {
      return useMutation(getUpdateInvoiceMutationOptions(options));
    }

/**
 * @summary List requirements for appointments
 */
export const getListRequirementsUrl = (params?: ListRequirementsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/requirements?${stringifiedParams}` : `/api/requirements`
}

export const listRequirements = async (params?: ListRequirementsParams, options?: RequestInit): Promise<Requirement[]> => {

  return customFetch<Requirement[]>(getListRequirementsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRequirementsQueryKey = (params?: ListRequirementsParams,) => {
    return [
    `/api/requirements`, ...(params ? [params] : [])
    ] as const;
    }


export const getListRequirementsQueryOptions = <TData = Awaited<ReturnType<typeof listRequirements>>, TError = ErrorType<unknown>>(params?: ListRequirementsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRequirements>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRequirementsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRequirements>>> = ({ signal }) => listRequirements(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRequirements>>, TError, TData> & { queryKey: QueryKey }
}

export type ListRequirementsQueryResult = NonNullable<Awaited<ReturnType<typeof listRequirements>>>
export type ListRequirementsQueryError = ErrorType<unknown>


/**
 * @summary List requirements for appointments
 */

export function useListRequirements<TData = Awaited<ReturnType<typeof listRequirements>>, TError = ErrorType<unknown>>(
 params?: ListRequirementsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRequirements>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListRequirementsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create a requirement
 */
export const getCreateRequirementUrl = () => {




  return `/api/requirements`
}

export const createRequirement = async (createRequirementBody: CreateRequirementBody, options?: RequestInit): Promise<Requirement> => {

  return customFetch<Requirement>(getCreateRequirementUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createRequirementBody,)
  }
);}




export const getCreateRequirementMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRequirement>>, TError,{data: BodyType<CreateRequirementBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRequirement>>, TError,{data: BodyType<CreateRequirementBody>}, TContext> => {

const mutationKey = ['createRequirement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRequirement>>, {data: BodyType<CreateRequirementBody>}> = (props) => {
          const {data} = props ?? {};

          return  createRequirement(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRequirementMutationResult = NonNullable<Awaited<ReturnType<typeof createRequirement>>>
    export type CreateRequirementMutationBody = BodyType<CreateRequirementBody>
    export type CreateRequirementMutationError = ErrorType<unknown>

    /**
 * @summary Create a requirement
 */
export const useCreateRequirement = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRequirement>>, TError,{data: BodyType<CreateRequirementBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createRequirement>>,
        TError,
        {data: BodyType<CreateRequirementBody>},
        TContext
      > => {
      return useMutation(getCreateRequirementMutationOptions(options));
    }

/**
 * @summary Update requirement (mark as completed)
 */
export const getUpdateRequirementUrl = (id: number,) => {




  return `/api/requirements/${id}`
}

export const updateRequirement = async (id: number,
    updateRequirementBody: UpdateRequirementBody, options?: RequestInit): Promise<Requirement> => {

  return customFetch<Requirement>(getUpdateRequirementUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateRequirementBody,)
  }
);}




export const getUpdateRequirementMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRequirement>>, TError,{id: number;data: BodyType<UpdateRequirementBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRequirement>>, TError,{id: number;data: BodyType<UpdateRequirementBody>}, TContext> => {

const mutationKey = ['updateRequirement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRequirement>>, {id: number;data: BodyType<UpdateRequirementBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateRequirement(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRequirementMutationResult = NonNullable<Awaited<ReturnType<typeof updateRequirement>>>
    export type UpdateRequirementMutationBody = BodyType<UpdateRequirementBody>
    export type UpdateRequirementMutationError = ErrorType<unknown>

    /**
 * @summary Update requirement (mark as completed)
 */
export const useUpdateRequirement = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRequirement>>, TError,{id: number;data: BodyType<UpdateRequirementBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateRequirement>>,
        TError,
        {id: number;data: BodyType<UpdateRequirementBody>},
        TContext
      > => {
      return useMutation(getUpdateRequirementMutationOptions(options));
    }

/**
 * @summary List all editable content
 */
export const getListContentUrl = (params?: ListContentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/content?${stringifiedParams}` : `/api/content`
}

export const listContent = async (params?: ListContentParams, options?: RequestInit): Promise<SiteContent[]> => {

  return customFetch<SiteContent[]>(getListContentUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListContentQueryKey = (params?: ListContentParams,) => {
    return [
    `/api/content`, ...(params ? [params] : [])
    ] as const;
    }


export const getListContentQueryOptions = <TData = Awaited<ReturnType<typeof listContent>>, TError = ErrorType<unknown>>(params?: ListContentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listContent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListContentQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listContent>>> = ({ signal }) => listContent(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listContent>>, TError, TData> & { queryKey: QueryKey }
}

export type ListContentQueryResult = NonNullable<Awaited<ReturnType<typeof listContent>>>
export type ListContentQueryError = ErrorType<unknown>


/**
 * @summary List all editable content
 */

export function useListContent<TData = Awaited<ReturnType<typeof listContent>>, TError = ErrorType<unknown>>(
 params?: ListContentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listContent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListContentQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get content by key
 */
export const getGetContentUrl = (key: string,) => {




  return `/api/content/${key}`
}

export const getContent = async (key: string, options?: RequestInit): Promise<SiteContent> => {

  return customFetch<SiteContent>(getGetContentUrl(key),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetContentQueryKey = (key: string,) => {
    return [
    `/api/content/${key}`
    ] as const;
    }


export const getGetContentQueryOptions = <TData = Awaited<ReturnType<typeof getContent>>, TError = ErrorType<unknown>>(key: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getContent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContentQueryKey(key);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContent>>> = ({ signal }) => getContent(key, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(key), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetContentQueryResult = NonNullable<Awaited<ReturnType<typeof getContent>>>
export type GetContentQueryError = ErrorType<unknown>


/**
 * @summary Get content by key
 */

export function useGetContent<TData = Awaited<ReturnType<typeof getContent>>, TError = ErrorType<unknown>>(
 key: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getContent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetContentQueryOptions(key,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Update site content
 */
export const getUpdateContentUrl = (key: string,) => {




  return `/api/content/${key}`
}

export const updateContent = async (key: string,
    updateContentBody: UpdateContentBody, options?: RequestInit): Promise<SiteContent> => {

  return customFetch<SiteContent>(getUpdateContentUrl(key),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateContentBody,)
  }
);}




export const getUpdateContentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContent>>, TError,{key: string;data: BodyType<UpdateContentBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateContent>>, TError,{key: string;data: BodyType<UpdateContentBody>}, TContext> => {

const mutationKey = ['updateContent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateContent>>, {key: string;data: BodyType<UpdateContentBody>}> = (props) => {
          const {key,data} = props ?? {};

          return  updateContent(key,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateContentMutationResult = NonNullable<Awaited<ReturnType<typeof updateContent>>>
    export type UpdateContentMutationBody = BodyType<UpdateContentBody>
    export type UpdateContentMutationError = ErrorType<unknown>

    /**
 * @summary Update site content
 */
export const useUpdateContent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContent>>, TError,{key: string;data: BodyType<UpdateContentBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateContent>>,
        TError,
        {key: string;data: BodyType<UpdateContentBody>},
        TContext
      > => {
      return useMutation(getUpdateContentMutationOptions(options));
    }

/**
 * @summary List all leads
 */
export const getListLeadsUrl = (params?: ListLeadsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leads?${stringifiedParams}` : `/api/leads`
}

export const listLeads = async (params?: ListLeadsParams, options?: RequestInit): Promise<Lead[]> => {

  return customFetch<Lead[]>(getListLeadsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLeadsQueryKey = (params?: ListLeadsParams,) => {
    return [
    `/api/leads`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLeadsQueryOptions = <TData = Awaited<ReturnType<typeof listLeads>>, TError = ErrorType<unknown>>(params?: ListLeadsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLeads>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLeadsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLeads>>> = ({ signal }) => listLeads(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLeads>>, TError, TData> & { queryKey: QueryKey }
}

export type ListLeadsQueryResult = NonNullable<Awaited<ReturnType<typeof listLeads>>>
export type ListLeadsQueryError = ErrorType<unknown>


/**
 * @summary List all leads
 */

export function useListLeads<TData = Awaited<ReturnType<typeof listLeads>>, TError = ErrorType<unknown>>(
 params?: ListLeadsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLeads>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListLeadsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create or import a lead
 */
export const getCreateLeadUrl = () => {




  return `/api/leads`
}

export const createLead = async (createLeadBody: CreateLeadBody, options?: RequestInit): Promise<Lead> => {

  return customFetch<Lead>(getCreateLeadUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createLeadBody,)
  }
);}




export const getCreateLeadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLead>>, TError,{data: BodyType<CreateLeadBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLead>>, TError,{data: BodyType<CreateLeadBody>}, TContext> => {

const mutationKey = ['createLead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLead>>, {data: BodyType<CreateLeadBody>}> = (props) => {
          const {data} = props ?? {};

          return  createLead(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLeadMutationResult = NonNullable<Awaited<ReturnType<typeof createLead>>>
    export type CreateLeadMutationBody = BodyType<CreateLeadBody>
    export type CreateLeadMutationError = ErrorType<unknown>

    /**
 * @summary Create or import a lead
 */
export const useCreateLead = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLead>>, TError,{data: BodyType<CreateLeadBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createLead>>,
        TError,
        {data: BodyType<CreateLeadBody>},
        TContext
      > => {
      return useMutation(getCreateLeadMutationOptions(options));
    }

/**
 * @summary Bulk import leads
 */
export const getBulkImportLeadsUrl = () => {




  return `/api/leads/bulk-import`
}

export const bulkImportLeads = async (bulkImportLeadsBody: BulkImportLeadsBody, options?: RequestInit): Promise<BulkImportResult> => {

  return customFetch<BulkImportResult>(getBulkImportLeadsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bulkImportLeadsBody,)
  }
);}




export const getBulkImportLeadsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkImportLeads>>, TError,{data: BodyType<BulkImportLeadsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkImportLeads>>, TError,{data: BodyType<BulkImportLeadsBody>}, TContext> => {

const mutationKey = ['bulkImportLeads'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkImportLeads>>, {data: BodyType<BulkImportLeadsBody>}> = (props) => {
          const {data} = props ?? {};

          return  bulkImportLeads(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkImportLeadsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkImportLeads>>>
    export type BulkImportLeadsMutationBody = BodyType<BulkImportLeadsBody>
    export type BulkImportLeadsMutationError = ErrorType<unknown>

    /**
 * @summary Bulk import leads
 */
export const useBulkImportLeads = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkImportLeads>>, TError,{data: BodyType<BulkImportLeadsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkImportLeads>>,
        TError,
        {data: BodyType<BulkImportLeadsBody>},
        TContext
      > => {
      return useMutation(getBulkImportLeadsMutationOptions(options));
    }

/**
 * @summary Get lead by ID
 */
export const getGetLeadUrl = (id: number,) => {




  return `/api/leads/${id}`
}

export const getLead = async (id: number, options?: RequestInit): Promise<Lead> => {

  return customFetch<Lead>(getGetLeadUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLeadQueryKey = (id: number,) => {
    return [
    `/api/leads/${id}`
    ] as const;
    }


export const getGetLeadQueryOptions = <TData = Awaited<ReturnType<typeof getLead>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLead>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeadQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLead>>> = ({ signal }) => getLead(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLead>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLeadQueryResult = NonNullable<Awaited<ReturnType<typeof getLead>>>
export type GetLeadQueryError = ErrorType<unknown>


/**
 * @summary Get lead by ID
 */

export function useGetLead<TData = Awaited<ReturnType<typeof getLead>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLead>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLeadQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Update lead
 */
export const getUpdateLeadUrl = (id: number,) => {




  return `/api/leads/${id}`
}

export const updateLead = async (id: number,
    updateLeadBody: UpdateLeadBody, options?: RequestInit): Promise<Lead> => {

  return customFetch<Lead>(getUpdateLeadUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateLeadBody,)
  }
);}




export const getUpdateLeadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLead>>, TError,{id: number;data: BodyType<UpdateLeadBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLead>>, TError,{id: number;data: BodyType<UpdateLeadBody>}, TContext> => {

const mutationKey = ['updateLead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLead>>, {id: number;data: BodyType<UpdateLeadBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateLead(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLeadMutationResult = NonNullable<Awaited<ReturnType<typeof updateLead>>>
    export type UpdateLeadMutationBody = BodyType<UpdateLeadBody>
    export type UpdateLeadMutationError = ErrorType<unknown>

    /**
 * @summary Update lead
 */
export const useUpdateLead = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLead>>, TError,{id: number;data: BodyType<UpdateLeadBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateLead>>,
        TError,
        {id: number;data: BodyType<UpdateLeadBody>},
        TContext
      > => {
      return useMutation(getUpdateLeadMutationOptions(options));
    }

